import { LitElement } from 'lit';
import { debounceTime, fromEvent, tap } from 'rxjs';
import {
  dateFromMysqlDate,
  extractSolrDateFromFlatPickerInput,
} from './lib/solr-date-helper.js';

class ToujouSolrDateRangeFacet extends LitElement {
  static get is() {
    return 'toujou-solr-date-range-facet';
  }

  static get properties() {
    return {
      mode: {
        type: String,
      },
      changeEvent: {
        type: String,
        attribute: 'change-event',

      },
      debounceTime: {
        type: Number,
        attribute: 'debounce-time',
      },
      selectedDates: {
        type: String,
        attribute: 'selected-dates',
      },
    };
  }

  constructor() {
    super();
    this.mode = 'single';
    this.changeEvent = 'change';
    this.debounceTime = 1000;
    this.selectedDates = '';
  }

  createRenderRoot() {
    return this;
  }

  connectedCallback() {
    super.connectedCallback();
    this.dateChangeSubscription = fromEvent(this.querySelectorAll('.solr-facet_date-range'), this.changeEvent).pipe(
      debounceTime(this.debounceTime),
      tap(() => this._onDateRangeChange()),
    ).subscribe();
  }

  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    if (this.mode === 'range' && this.selectedDates !== '') {
      const dates = this.selectedDates.split(',').map(singleDate => dateFromMysqlDate(singleDate));
      this.dateFromInput._flatpickr.setDate(dates);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.dateChangeSubscription.unsubscribe();
  }

  _onDateRangeChange() {
    const { facetUrl, facetResetUrl } = this.dataset;
    const dateFrom = extractSolrDateFromFlatPickerInput(this.dateFromInput);

    let dateUntil = '';
    if (this.mode === 'range') {
      dateUntil = extractSolrDateFromFlatPickerInput(this.dateFromInput, '2359', 1);
    } else {
      dateUntil = extractSolrDateFromFlatPickerInput(this.dateUntilInput, '2359');
    }

    let url = facetResetUrl;

    if (dateFrom !== '' || dateUntil !== '') {
      url = facetUrl.replace(encodeURI('___FROM___'), dateFrom)
        .replace(encodeURI('___TO___'), dateUntil);
    }

    this.dispatchEvent(
      new CustomEvent('toujou-solr-search-facade-value-changed', {
        bubbles: true,
        composed: true,
        detail: {
          url,
        },
      }),
    );
  }

  /**
   * @return {HTMLInputElement}
   */
  get dateFromInput() {
    return this.querySelector('.solr-facet_date-range--date-from');
  }

  /**
   * @return {HTMLInputElement}
   */
  get dateUntilInput() {
    return this.querySelector('.solr-facet_date-range--date-until');
  }
}

customElements.define(ToujouSolrDateRangeFacet.is, ToujouSolrDateRangeFacet);
